import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyRichText from '../../components/forms/richText'

const AppointmentDetail = (props) => {
  const { detail } = props.data
  const [errorMsg, setErrorMsg] = useState({})
  const [formValue, setFormValue] = useState({ course_description: '' })

  useEffect(() => {
    setFormValue({course_description: detail.course_description || ''})
  }, [detail])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.course_description) {
      setErrorMsg({courseDescriptionEmpty: '课程完成详情不能为空'})
      return false
    }

    axios.post('/admin/appointment/course_description/edit', { 
      appointment_record_oid: detail.oid,
      course_description: formValue.course_description
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getAppointmentData()
          message.success('保存成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    props.isCancel()
  }

  return (
    <Modal 
      title="填写课程详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>预约日期</div>
          <div className='public-datail-content'>{detail.appointment_date}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>预约时间</div>
          <div className='public-datail-content'>{detail.start_time} - {detail.end_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>预约教练</div>
          <div className='public-datail-content'>{detail.coach_name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>预约用户</div>
          <div className='public-datail-content'>{detail.user_name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>提交时间</div>
          <div className='public-datail-content'>{detail.submission_time}</div>
        </div>
        <MyRichText
          required
          label='课程完成详情'
          id='course_description'
          value={formValue.course_description}
          setValue={setFormValue}
          errorMsg={errorMsg.courseDescriptionEmpty}
        />
      </div>
    </Modal>
  )
}

export default AppointmentDetail
